import { app } from '../../../../../../app';
import { Controller } from './add-account-to-group.controller';

app.component('companyUserDirectoriesManageGroupAccountsAdd', {
    bindings: {
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./add-account-to-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/add/add-account-to-group.component.js